export function toNum(s: string | number): number {
  const n = typeof s === "number" ? s : Number(s);
  return Number.isFinite(n) ? n : 0;
}

export function fmtInt(s: string | number): string {
  const n = Math.floor(toNum(s));
  return n.toLocaleString("en-US");
}

export function fmtCompact(s: string | number): string {
  const n = toNum(s);
  if (n >= 1_000_000_000) return (n / 1_000_000_000).toFixed(1).replace(/\.0$/, "") + "B";
  if (n >= 1_000_000) return (n / 1_000_000).toFixed(1).replace(/\.0$/, "") + "M";
  if (n >= 10_000) return (n / 1_000).toFixed(1).replace(/\.0$/, "") + "K";
  return fmtInt(n);
}

export function fmtClock(ms: number): string {
  const s = Math.max(0, Math.ceil(ms / 1000));
  const m = Math.floor(s / 60);
  const r = s % 60;
  return String(m).padStart(2, "0") + ":" + String(r).padStart(2, "0");
}

export function fmtAgo(ts: number, now: number): string {
  if (!ts || ts <= 0) return "—";
  const d = now - ts;
  if (d <= 0) return "now";
  if (d < 60000) return Math.floor(d / 1000) + "s ago";
  if (d < 3600000) return Math.floor(d / 60000) + "m ago";
  if (d < 86400000) return Math.floor(d / 3600000) + "h ago";
  return Math.floor(d / 86400000) + "d ago";
}

export { bakeryStatus, specLabel, specTool } from "@cookies/shared/status";


